import type {
  ChartData,
  ChartDefinition,
  BuildChartContext,
  ChartViewModel,
} from '../catalog/types';
import { ChartType } from 'shared/types/analytics';

function isChartDataEmpty(
  definition: ChartDefinition,
  data: ChartData
): boolean {
  if (definition.type === ChartType.triplet) {
    return !(data.tripletValues?.some((value) => value !== undefined) ?? false);
  }

  if (definition.type === ChartType.line) {
    return (data.lineSeries?.length ?? 0) === 0;
  }

  return data.values.length === 0;
}

export function buildChartViewModel(
  definition: ChartDefinition,
  data: ChartData,
  _ctx: BuildChartContext
): ChartViewModel {
  return {
    type: definition.type,
    isEmpty: isChartDataEmpty(definition, data),
  };
}
